import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

const rootNode = document.getElementById('root');
ReactDOM.render(<App />, rootNode);